<script type="text/jsx">
import Add from './add';
import Edit from './edit';
import BuyNow from './buy-now';
import Readonly from './readonly.vue';
import planPropsMixin from '@/plans/mx/plan-props';
import { planTypes } from '@/common/constants';

export default {
  mixins: [planPropsMixin],
  render() {
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};

    if (this.$context.is.add2cart) {
      return this.$context.type !== planTypes.TOLLFREE ? <Readonly {...context}/> : <Add {...context} />;
    }
    if (this.$context.is.edit) {
      return this.$context.type !== planTypes.TOLLFREE ? <Readonly {...context}/> : <Edit {...context} />;
    }
    if (this.$context.is.pro2biz) {
      return <Readonly {...context}/>;
    }
    if(this.$context.is.edu2esc) {
      return <Readonly {...context}/>;
    }
    return <BuyNow {...context} />;
  },
};
</script>
